export function RedesSociais({
  label,
  hide,
}: {
  hide?: boolean;
  label?: string;
}) {
  if (!label?.trim() || hide) return null;

  return (
    <div className="mt-2 flex items-center text-base text-gray-700">
      <img src="/facebook.png" alt="Whastapp" width={24} />
      <img className="ml-1" src="/instagram.png" alt="Whastapp" width={24} />
      <img className="ml-1" src="/x.png" alt="Whastapp" width={24} />
      <div className="ml-2">
        <span>
          <strong className="font-normal">{label}</strong>
        </span>
      </div>
    </div>
  );
}
